import axios from '../../localAxios';
import { copyToWorkspaceURL } from '../workspacesURLs';

interface CopyToWorkspaceProps {
  workspaceId: string;
  quizIds: string[];
  from: string;
  parentId: string | null;
}
export const copyToWorkspace = async ({
  workspaceId,
  quizIds,
  from,
  parentId = null,
}: CopyToWorkspaceProps) => {
  const url = copyToWorkspaceURL(workspaceId);
  const response = await axios.post<CopyToWorkspaceProps>(url.href, {
    workspace_quiz_ids: quizIds,
    parent_folder_id: parentId,
    source_workspace_id: from,
  });
  return response.data;
};
